import { Thread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/models.pb';
import { QueryClient } from 'react-query';
import { getSchemaQueryKey } from '@frontend/react-query-helpers';
import { serviceName } from '../../service';
import { ServiceQueries } from '../../types';

export const setupGetThreadDetailsCaches = (queryClient: QueryClient, thread: Thread) => {
  const isAutomated = !!thread.messages[0]?.autogeneratedBy;
  if (!isAutomated) {
    queryClient.setQueryData(
      getSchemaQueryKey<ServiceQueries, 'GetThreadDetails'>({
        serviceName,
        endpointName: 'GetThreadDetails',
        request: {
          threadId: thread.id,
          locationId: thread.locationId,
          excludeAutomatedLastMessage: true,
        },
      }),
      { thread }
    );
    queryClient.setQueryData(
      getSchemaQueryKey<ServiceQueries, 'GetThreadDetails'>({
        serviceName,
        endpointName: 'GetThreadDetails',
        request: {
          threadId: thread.id,
          locationId: thread.locationId,
        },
      }),
      { thread }
    );
  }
  queryClient.setQueryData(
    getSchemaQueryKey<ServiceQueries, 'GetThreadDetails'>({
      serviceName,
      endpointName: 'GetThreadDetails',
      request: {
        threadId: thread.id,
        locationId: thread.locationId,
        excludeAutomatedLastMessage: false,
      },
    }),
    { thread }
  );
};
